import { Button } from '@/components/ui/Button'
import { Modal } from '@/components/ui/Modal'
import type { DirtyGuard } from '@/lib/dirtyGuard'

/** The prompt raised by `useDirtyGuard` when a form with edits is about to be abandoned. */
export function UnsavedChangesDialog({ guard }: { guard: DirtyGuard }) {
  return (
    <Modal
      open={guard.isBlocked}
      onClose={guard.keepEditing}
      title="Discard your changes?"
      description="This form has edits that have not been saved."
      footer={
        <>
          <Button variant="secondary" onClick={guard.keepEditing}>
            Keep editing
          </Button>
          <Button variant="danger" onClick={guard.discard}>
            Discard
          </Button>
        </>
      }
    >
      <p className="text-sm text-slate-600 dark:text-slate-300">
        Leaving now loses what you typed. Nothing has been sent to the server yet.
      </p>
    </Modal>
  )
}
